import React, { useState } from 'react';
import { Button } from "react-bootstrap";
import { InputAdornment, IconButton } from '@mui/material';
import Visibility from "@mui/icons-material/Visibility";
import VisibilityOff from "@mui/icons-material/VisibilityOff";

import { CheckButton } from "../../Icons/Icons";
import Routes from '../../routes';

import "./Login.css";
import { Input, LoadingButtonV4 } from '../Common';
import { trakrefFontFamily } from '../../utils';

const PasswordEyeIconButton = ({ showPassword, handleClickShowPassword }) => {
    return (
        <InputAdornment position="end">
            <IconButton
                aria-label="toggle password visibility"
                onClick={handleClickShowPassword}
                onMouseDown={(e) => e.preventDefault()}
                disableRipple
                sx={{ padding: "0px !important" }}
            >
                {showPassword ? <VisibilityOff /> : <Visibility />}
            </IconButton>
        </InputAdornment>
    );
};

const LoginForm = ({
    login,
    username,
    setUsername,
    error,
    setError,
    password,
    setPassword,
    loading,
    setRememberMe,
    rememberMe,
    setforgotButtonModalOpen,
    forgotButtonModalOpen
}) => {

    const [showPassword, setShowPassword] = useState(false);
    const [showPasswordField, setShowPasswordField] = useState(false);

    const onsubmitLogin = async (e) => {
        e.preventDefault();

        if (showPasswordField)
            return login(e);

        const response = await fetch(Routes.Account.GetUserInfoLogin(username), {
            method: 'GET',
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json',
            },
        });

        const data = await response.json();

        if ('isSSO' in data && data.isSSO) {
            document.location = data.redirectUrl + data.instanceId;
            return;
        }

        setShowPasswordField(true);
        setError(false);
    }

    return (
        <form onSubmit={(e) => onsubmitLogin(e)} className="login-form" show="SSOLogin == false">
            <img
                className="loginFormLogo"
                src='/images/logo_2025.svg'
                alt="logo"
            />
            <div className="LoginTitle">Welcome Back</div>
            <Input
                autoFocus
                fullWidth
                label="Username or Email Address"
                value={username}
                onChange={e => setUsername(e.target.value)}
                error={!!error}
                helperText={""}
                sx={{
                    marginBottom: "1rem"
                }}
            />

            {showPasswordField && (
                <Input
                    autoFocus
                    fullWidth
                    label="Password"
                    type={showPassword ? "text" : "password"}
                    value={password}
                    onChange={e => setPassword(e.target.value)}
                    error={!!error}
                    helperText={""}
                    sx={{
                        marginBottom: "1rem"
                    }}
                    endAdornment={<PasswordEyeIconButton showPassword={showPassword} handleClickShowPassword={() => setShowPassword(x => !x)} />}
                />
            )}

            {error && (
                <div className="login-error">
                    {error}
                </div>
            )}
            <br />
            <LoadingButtonV4
                type="submit"
                buttonText={"Login"}
                disabled={!username}
                loading={loading}
            />

            <div className={`login-bottom-actions flex f-row ${showPasswordField ? "" : "full-width-text"}`}>
                {showPasswordField && (
                    <>
                        <div className="flex f-ac clickable" onClick={() => setRememberMe(!rememberMe)}>
                            <CheckButton size={18} color={"#317C8C"} selected={rememberMe} />
                            <label className="checkbox-label">Remember me</label>
                        </div>
                    </>
                )}
                <div className="clickable" onClick={() => setforgotButtonModalOpen(!forgotButtonModalOpen)}>
                    <p className="forgot-password-label">
                        Forgot your password?
                    </p>
                </div>
            </div>
        </form>
    )
}

export default LoginForm;